const autoNgTemplateLoaderTemplate4 = require('./help/documentation.html');
const autoNgTemplateLoaderTemplate5 = require('./help/article.html');
const autoNgTemplateLoaderTemplate6 = require('./help/support.html');
const autoNgTemplateLoaderTemplate7 = require('./help/about.html');
const autoNgTemplateLoaderTemplate8 = require('./system/status.html');
const autoNgTemplateLoaderTemplate9 = require('./system/diagnostics.html');
const autoNgTemplateLoaderTemplate10 = require('./errors/error-page.html');

import angular from 'angular';

import { ShbSystemService } from '../services/system.service';
import { AboutController, DocumentationArticleController, DocumentationController, SupportController } from './help/controllers';
import { SystemDiagnosticsController, SystemStatusController } from './system/controllers';
import { ErrorPageController } from './errors/controllers';
import './pages.css';

/*
 * Определения компонентов вынесены в отдельные объекты, а `templateUrl` занимает
 * отдельную строку: auto-ngtemplate-loader заменяет путь на require() только тогда,
 * когда `templateUrl` начинает строку и строковый литерал её завершает. При записи
 * в одну строку вида `{ templateUrl: '…', controller: … }` замена молча не выполнялась,
 * и шаблоны не попадали в сборку — страницы возвращали 404 при открытии.
 */
const shbDocumentationPage = {
  templateUrl: autoNgTemplateLoaderTemplate4,
  controller: DocumentationController,
};

const shbDocumentationArticlePage = {
  templateUrl: autoNgTemplateLoaderTemplate5,
  controller: DocumentationArticleController,
};

const shbSupportPage = {
  templateUrl: autoNgTemplateLoaderTemplate6,
  controller: SupportController,
};

const shbAboutPage = {
  templateUrl: autoNgTemplateLoaderTemplate7,
  controller: AboutController,
};

const shbSystemStatusPage = {
  templateUrl: autoNgTemplateLoaderTemplate8,
  controller: SystemStatusController,
};

const shbSystemDiagnosticsPage = {
  templateUrl: autoNgTemplateLoaderTemplate9,
  controller: SystemDiagnosticsController,
};

const shbErrorPage = {
  templateUrl: autoNgTemplateLoaderTemplate10,
  controller: ErrorPageController,
};

/**
 * Страницы разделов «Система» и «Помощь» и страницы ошибок.
 */
export default angular
  .module('shbdeployer.pages', [])
  .factory('ShbSystemService', ShbSystemService)
  .component('shbDocumentationPage', shbDocumentationPage)
  .component('shbDocumentationArticlePage', shbDocumentationArticlePage)
  .component('shbSupportPage', shbSupportPage)
  .component('shbAboutPage', shbAboutPage)
  .component('shbSystemStatusPage', shbSystemStatusPage)
  .component('shbSystemDiagnosticsPage', shbSystemDiagnosticsPage)
  .component('shbErrorPage', shbErrorPage)
  .config(configureRoutes).name;

/* @ngInject */
function configureRoutes($stateRegistryProvider) {
  const states = [
    { name: 'shbdeployer.help', abstract: true, url: '/help' },
    { name: 'shbdeployer.help.documentation', url: '/documentation', views: { 'content@': { component: 'shbDocumentationPage' } } },
    {
      name: 'shbdeployer.help.article',
      url: '/documentation/:articleId',
      views: { 'content@': { component: 'shbDocumentationArticlePage' } },
    },
    { name: 'shbdeployer.help.support', url: '/support', views: { 'content@': { component: 'shbSupportPage' } } },
    { name: 'shbdeployer.help.about', url: '/about', views: { 'content@': { component: 'shbAboutPage' } } },

    { name: 'shbdeployer.system', abstract: true, url: '/system' },
    { name: 'shbdeployer.system.status', url: '/status', views: { 'content@': { component: 'shbSystemStatusPage' } } },
    { name: 'shbdeployer.system.diagnostics', url: '/diagnostics', views: { 'content@': { component: 'shbSystemDiagnosticsPage' } } },

    // Страницы ошибок отображаются без боковой панели
    { name: 'shbdeployer.error', abstract: true, url: '/error', views: { 'sidebar@': {} } },
    {
      name: 'shbdeployer.error.forbidden',
      url: '/403',
      params: { message: null, path: null, correlationId: null },
      data: { code: 403 },
      views: { 'content@': { component: 'shbErrorPage' } },
    },
    {
      name: 'shbdeployer.error.notFound',
      url: '/404',
      params: { message: null, path: null, correlationId: null },
      data: { code: 404 },
      views: { 'content@': { component: 'shbErrorPage' } },
    },
    {
      name: 'shbdeployer.error.serverError',
      url: '/500',
      params: { message: null, path: null, correlationId: null },
      data: { code: 500 },
      views: { 'content@': { component: 'shbErrorPage' } },
    },
  ];
  states.forEach((state) => $stateRegistryProvider.register(state));
}
